/* globals $:false */

import ReportDetailM from './reportm.model.reportdetail.js';

import ui from '@cob/ui-genesis/cob.ui.js';
import utils from '@cob/ui-genesis/cob.utils.js';

var ReportsM = function(core){
  this._core = core;
  this._reportMs = [];
  this._entityReports = undefined;
};

ReportsM.prototype.reset = function(){
    //Clear the available reports
    this._reportMs.length = 0;
};

ReportsM.prototype.loadReports = function() {
    var _this = this;

    $.ajax({
        'url': 'reportm/reports',
        'type' : 'GET',
        success: function(data) {
            if (data.reports) {

                data.reports.forEach(function(report) {
                    _this._reportMs.push(new ReportDetailM(_this._core, report));
                });

                _this._core.publish("reportm:reports-loaded");
            }
        },
        error: function(req) {

            var errorMsg = _this._core.translateString("reportm", "reports.error.getReports");

            _this.reset();

            ui.notification.showError(errorMsg, true);

            window.console.log("ENTITY-REPORTS:error: " +
                               req.status + " : " +
                               req.statusText + ":" +
                               req.responseText);

            _this._core.publish("reportm:reports-not-available");
        }
    });
};

ReportsM.prototype.loadReportsForEntities = function() {
    var _this = this;

    this._entityReports = undefined;

    $.ajax({
        'url': 'reportm/reports/entities',
        'type' : 'GET',
        success: function(data) {
            if (data.entityReports) {

                _this._entityReports = {};

                utils.forEachOwn(data.entityReports, function(entity){
                    var entityReports = data.entityReports[entity];

                    _this._entityReports[entity] = entityReports.map(function(report){
                        return new ReportDetailM(_this._core, report);
                    });
                });

                _this._core.publish("reportm:entity-reports-loaded");
            }
        },
        error: function(req) {

            var errorMsg = _this._core.translateString("reportm", "reports.error.getReports");

            ui.notification.showError(errorMsg, true);

            window.console.log("ENTITY-REPORTS:error: " +
                               req.status + " : " +
                               req.statusText + ":" +
                               req.responseText);

            _this._core.publish("reportm:entity-reports-not-available");
        }
    });
};

ReportsM.prototype.getReportsFor = function(entity){
   return this._entityReports[entity] || [];
};

ReportsM.prototype.getReports = function(){
    return this._reportMs;
};

ReportsM.prototype.getReportDetailMFor = function(reportName){

    for(var index = 0; index < this._reportMs.length; index++){
        if(this._reportMs[index].getReportFileName() === reportName){
            return this._reportMs[index];
        }
    }

    return undefined;
};

export default ReportsM;
